export default defineNuxtRouteMiddleware( async () => {
  const contentResource = useContentDeliveryResource();
  const orderResource = useOrderResource();

  const currentPage = useHeadlessDataState();

  const loadedStep = currentPage.value?.subType ?? "register";

  const auth = useAuthStore();
  const basketStore = useBasketStore();

  const [
    { data: register },
    { data: selectSubscription },
    { data: selectPreferences },
    { data: checkout },
    { data: linkSchools },
  ] = await Promise.all( [
    contentResource.getByTypeSingle( "register" ),
    contentResource.getByTypeSingle( "selectSubscription" ),
    contentResource.getByTypeSingle( "selectPreferences" ),
    contentResource.getByTypeSingle( "checkout" ),
    contentResource.getByTypeSingle( "linkSchools" ),
  ] );

  const url = useRequestURL();
  const externalUrl = ( path: string ) => url.origin + path;

  const hasValidAddress = () => {
    const currentAddress = auth.webAccount?.address;
    return !!currentAddress && currentAddress.address1 !== "NO ADDRESS FOUND";
  };

  // If not logged in and not on the register page, redirect to register page
  if ( !auth.isLoggedIn && loadedStep !== "register" ) {
    if ( register.value ) {
      return navigateTo( externalUrl( register.value.route.path ), { external: true } );
    } else {
      console.warn( "Cannot redirect to register page, register page not found" );
    }
  }

  // Dealt with not logged in case, now for logged in... working backwards from end of journey
  const { data: purchasedProducts } = await orderResource.listPurchasedProductsForWebAccount();

  // If logged in and has purchased products, redirect to preferences page
  if ( auth.isLoggedIn && purchasedProducts.value.length > 0 && loadedStep !== "preferences" ) {
    if ( selectPreferences.value ) {
      return navigateTo( externalUrl( selectPreferences.value.route.path ), { external: true } );
    } else {
      console.warn( "Cannot redirect to preferences page, preferences page not found" );
    }
  }

  // If logged in, has a product in the basket, has chosen an org, redirect to checkout
  if ( auth.isLoggedIn && !basketStore.basketEmpty && hasValidAddress() && loadedStep !== "checkout" ) {
    if ( checkout.value ) {
      return navigateTo( externalUrl( checkout.value.route.path ), { external: true } );
    } else {
      console.warn( "Cannot redirect to checkout page, checkout page not found" );
    }
  }

  // If logged in, has a product in the basket, but has NOT chosen an org, redirect to link schools
  if ( auth.isLoggedIn && !basketStore.basketEmpty && !hasValidAddress() && loadedStep !== "linkSchools" ) {
    if ( linkSchools.value ) {
      return navigateTo( externalUrl( linkSchools.value.route.path ), { external: true } );
    } else {
      console.warn( "Cannot redirect to link schools page, link schools page not found" );
    }
  }

  // If logged in, has no product in the basket, and hasn't chosen an org, redirect to link schools
  if ( auth.isLoggedIn && basketStore.basketEmpty && !hasValidAddress() && loadedStep !== "linkSchools" ) {
    if ( linkSchools.value ) {
      return navigateTo( externalUrl( linkSchools.value.route.path ), { external: true } );
    } else {
      console.warn( "Cannot redirect to link schools page, page not found" );
    }
  }

  // If logged in, has no product in the basket, and has chosen an org, redirect to preferences
  if ( auth.isLoggedIn && basketStore.basketEmpty && hasValidAddress() && loadedStep !== "selectPreferences" ) {
    if ( selectPreferences.value ) {
      return navigateTo( externalUrl( selectPreferences.value.route.path ), { external: true } );
    } else {
      console.warn( "Cannot redirect to preferences page, preferences page not found" );
    }
  }
} );
